import { SetStateAction } from "jotai";
import { IAllFilterData } from "./utils";
import { checkTitle, mergeClass } from "../../utils";
import { IDropdownOption } from "../../utils/customisation";
import Select from "react-select";

export interface IFilterState {
  action?: string;
  button?: string;
  path?: string;
  info?: string;
  models?: string;
  items?: string;
}

const FilterSelect = ({
  options,
  defaultLabel,
  onChange,
  className,
}: {
  options: string[];
  defaultLabel?: string;
  className?: string;
  onChange: (e: any) => void;
}) => (
  <select
    className={mergeClass(
      "border rounded px-3 py-1.5 text-sm max-w-[80%]",
      className
    )}
    onChange={(e) =>
      onChange(e.target.value === "All" ? undefined : e.target.value)
    }
  >
    {defaultLabel && <option label={defaultLabel}>All</option>}
    {options.map((label, index) => (
      <option key={index}>{checkTitle(label)}</option>
    ))}
  </select>
);

const FilterDropdown = ({
  options,
  onChange,
  defaultLabel,
  className,
  value,
}: {
  value?: string;
  options: string[];
  defaultLabel?: string;
  className?: string;
  onChange: (e: any) => void;
}) => {
  const defaultValue = { label: defaultLabel || "All", value: "All" };
  const parsedOptions = [
    defaultValue,
    ...options.map((o) => {
      return {
        label: o === "landmark" ? "Landmarks" : checkTitle(o),
        value: o,
      };
    }),
  ];
  return (
    <Select
      className={mergeClass("min-w-[12rem] text-sm", className)}
      defaultValue={defaultValue}
      options={parsedOptions}
      value={value ? { label: checkTitle(value), value } : defaultValue}
      onChange={(e) => onChange(e?.value === "All" ? undefined : e?.value)}
    />
  );
};

const FilterMenu = ({
  filters,
  setFilters,
  filterData,
}: {
  filters: IFilterState;
  filterData: IAllFilterData;
  setFilters: React.Dispatch<SetStateAction<IFilterState>>;
}) => {
  const updateFilter = (
    key: keyof IAllFilterData,
    newFilter: string | undefined
  ) => {
    const newFilters = { ...filters, [key]: newFilter };
    if (!newFilters[key]) delete newFilters[key];
    setFilters(newFilters);
  };

  return (
    <div className="flex gap-4">
      {filterData.action && (
        <FilterSelect
          defaultLabel={"All Actions"}
          options={filterData.action}
          onChange={(e) => updateFilter("action", e)}
        />
      )}
      {filterData.button && (
        <FilterSelect
          defaultLabel={"All Buttons"}
          options={filterData.button}
          onChange={(e) => updateFilter("button", e)}
        />
      )}
      {filterData.path && (
        <FilterSelect
          defaultLabel={"All Paths"}
          options={filterData.path}
          onChange={(e) => updateFilter("path", e)}
        />
      )}
      {filterData.info && (
        <FilterSelect
          defaultLabel={"All Info"}
          options={filterData.info}
          onChange={(e) => updateFilter("info", e)}
        />
      )}
      {filterData.models && (
        <FilterSelect
          defaultLabel={"All Models"}
          options={filterData.models}
          onChange={(e) => updateFilter("models", e)}
        />
      )}
      {filterData.items && (
        <FilterSelect
          defaultLabel={"All Items"}
          options={filterData.items}
          onChange={(e) => updateFilter("items", e)}
        />
      )}
    </div>
  );
};

export { FilterSelect, FilterMenu, FilterDropdown };
